import { render, staticRenderFns } from "./Yuyue.vue?vue&type=template&id=152f76f8&"
import script from "./Yuyue.vue?vue&type=script&lang=js&"
export * from "./Yuyue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports